import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BasePaths } from '@app/constants/routes';
/**
 * @description
 *
 * Stores query params to session and removes from url
 */

@Injectable()
export class MemberPayrollHyperlinkGuard implements CanActivate {
    constructor(
        private router: Router
    ) {

    }

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | UrlTree {

        const pyId = route.queryParamMap.get('PY_ID');

        if (pyId) {

            sessionStorage.setItem('PY_ID', pyId);

            return this.router.createUrlTree(
                [BasePaths.Members]
            );
        }

        return true;
    }
}


